module.exports = __webpack_public_path__ + "img/ic_bloc_sinistre.e5ff4205.svg";